import React from 'react';
import { P as PhonePlatformContext } from './PhonePlatformContext-c729c8cb.js';

function usePhonePlatform() {
  return React.useContext(PhonePlatformContext);
}

export { usePhonePlatform as u };
